export const SEARCH_REQUEST_TIMEOUT_MS = 5_000;

export const withRequestTimeout = (signal?: AbortSignal, timeoutMs = SEARCH_REQUEST_TIMEOUT_MS): AbortSignal => {
  const timeout = AbortSignal.timeout(timeoutMs);
  return signal ? AbortSignal.any([signal, timeout]) : timeout;
};
